import { Box, Chip, Tooltip } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    marginRight: 5,
  },
  styleTop: {
    position: 'absolute',
    zIndex: 100,
    top: theme.spacing(0.75),
    right: theme.spacing(0.75),
    display: 'flex',
  },
  styleInline: {
    display: 'inline-block',
    marginLeft: 10,
  },
  whiteBg: {
    backgroundColor: 'white',
  },
}));

interface IProps {
  location: 'top' | 'inline';
  segmentId: number;
  priority: number;
}

const CurationInfo = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { segmentId, priority } = props;
  const className = props.location === 'top' ? classes.styleTop : classes.styleInline;

  return (
    <Box className={className}>
      <Tooltip title="segment id">
        <Chip color="default" label={segmentId} size="small" className={classes.label} />
      </Tooltip>
      <Tooltip title="priority">
        <Chip color="primary" variant="outlined" label={priority} size="small" className={classes.whiteBg} />
      </Tooltip>
    </Box>
  );
};

export default CurationInfo;
